import React from "react";

export default function LicenseRequirements() {
  return (
    <div>
      <h4 style={{ textAlign: "center" }}>
        Certification of Compliance - Driver License Requirements
      </h4>
      <p>
        <b>Motor Carrier Instructions:</b> The requirements in Part 383 apply to
        every driver who operates in Intrastate, Interstate, or foreign commerce
        and operates a vehicle weighing 26,001 pounds or more, can transport
        more than 15 people, or transports hazardous materials that require
        placarding.
      </p>
      <p>
        Motor Carrier Instructions: The requirements in Part 383 apply to every
        driver who operates in Intrastate, Interstate, or foreign commerce and
        operates a vehicle weighing 26,001 pounds or more, can transport more
        than 15 people, or transports hazardous materials that require
        placarding.
      </p>
      <p>
        <b>DRIVER REQUIREMENTS:</b> Parts 383 and 391 of The Federal Motor
        Carrier Safety Regulations contain some requirements that you as a
        driver must comply with. These requirements are in effect as of July
        1,1987. They are as follows:
      </p>
      <ol>
        <li>
          You, as a commercial vehicle driver, may not possess more than one
          license. If you currently have more than one license, you should keep
          the license from your state of residence and return the additional
          licenses to the states that issued them. Destroying a license does not
          close the record in the state that issued it; you must notify the
          state. If a multiple license has been lost, stolen, or destroyed, you
          should close your record by notifying the state of issuance that you
          no longer want to be licensed by that state.
        </li>
        <li>
          Part 392.42 and Part 383.33 of the Federal Motor Carrier Safety
          Regulations require that you notify your employer the next business
          day of any revocation or suspension of your driver's license. In
          addition, Part 383.31 requires that any time you violate a state or
          local traffic law (other than parking), you must report it to your
          employer motor carrier and the state that issued your license within
          30 days.
        </li>
      </ol>
    </div>
  );
}
